'use strict';

module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: require('./block-elements.json')
};



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-parse/lib/defaults.js
// module id = 103
// module chunks = 96961042003272 139266963665775